import React from 'react'
import { UserEditFormBuyerStyle } from './styled'
import { components } from 'react-select'
import makeAnimated from 'react-select/animated'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  Checkbox,
  SelectBoxCategoryUser,
  Breadcrumbs,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { EMAIL_REGEX } from 'helpers'
import { usermanageController } from '../../apiService'
import { toast } from 'react-toastify'
import { store } from 'store'
import { trimmedString } from '../../helpers/functions/strRemoveWhiteSpace'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'
import { map, filter } from 'lodash'
import { localStorageService } from '../../helpers'
const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ color: '#4b4acb' }}
        />{' '}
        <label style={{ color: '#4b4acb' }}>{props.label}</label>
      </components.Option>
    </div>
  )
}
const allOption = {
  label: 'Select all',
  value: 'All',
}
const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue()
  let toBeRendered = children
  if (currentValues.some(val => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]]
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  )
}
const MultiValue = props => {
  let labelToBeDisplayed = `${props.data.label}`
  if (props.data.value === allOption.value) {
    labelToBeDisplayed = 'All items are selected.'
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  )
}
const animatedComponents = makeAnimated()
export class UserEditFormBuyerContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      optionsRole: [
        { value: 3, label: 'Admin' },
        { value: 4, label: 'User' },
        { value: 7, label: 'Risk Management' },
      ],
      isEditPageState: false,
      isActive: true,
      status: '',
      is_active: 0,
      name: '',
      email: '',
      full_name: '',
      Phone: '',
      empRefId: '',
      companyId: '',
      ChackRole: 0,
      nameValid: false,
      emailValid: false,
      phoneValid: false,
      roleValid: false,
      role: '',
      optionsRoleValue: [],
      adminRole: true,
      userRole: true,
      riskManagemntRole: true,
      purchaserRole: true,
      tecRole: true,
      approverRole: false,
      observerRole: false,
      lockSave: false,
      empRefIdValid: false,
      formValid: true,
      BuyerList: [],
      html: 'Edit <b>me</b> !',
      id: '',
      toastActive: false,
      submitted: true,
      clickResendmail: false,
      acountStatus: null,
      disabledToggle: false,
      isEvent: false,
      categoryCompany: [],
      valueCategoryCompany: '',
      isErrorCategoryCompany: false,
    }
  }
  componentDidMount = () => {
    this._isMounted = true
    try {
      let url = window.location.pathname
      let id = url.substring(url.lastIndexOf(':') + 1)
      this.setState({ id: id })
      this._fetchgetUserID(id)
      this.funcGetCategoryCompany()
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetCategoryCompany() {
    const companyId = localStorageService.getCompanyId()
    const params = {
      companyId,
    }
    const categories = await usermanageController().getCategories(params)
    if (categories) {
      const arrCat = map(categories, (value, index) => {
        const { ID, name } = value
        return {
          value: ID,
          label: name,
        }
      })
      if (this._isMounted) {
        this.setState({ categoryCompany: arrCat })
      }
    }
  }
  _fetchgetUser() {
    if (this._isMounted) {
      this.setState({ BuyerListLoading: true })
    }
    return usermanageController()
      .BuyerList()
      .then(res => this.mapState(res.records))
      .finally(() => {
        if (this._isMounted) {
          this.setState({ BuyerListLoading: false })
        }
      })
  }
  _fetchgetUserID(id) {
    if (this._isMounted) {
      this.setState({ BuyerListLoading: true })
    }
    return usermanageController()
      .getUser(id)
      .then(res => this.mapState(res))
      .finally(() => {
        if (this._isMounted) {
          this.setState({ BuyerListLoading: false })
        }
      })
  }

  _fetchUpdateBuyerStatus(s) {
    if (this._isMounted) {
      this.setState({ BuyerListLoading: true })
    }
    let data = {
      buyer_id: parseInt(this.state.id),
      status: s == true ? 1 : 0,
    }
    return usermanageController()
      .updateBuyerStatus(data)
      .then(res => {
        this.toastActive(res.message)
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ toastActive: true })
        }
      })
  }

  mapState = res => {
    const { categories } = res
    const mapCategoriesCompany = map(categories, data => {
      const { ID, name } = data
      return { value: ID, label: name }
    })
    if (this._isMounted) {
      this.setState({
        BuyerList: res,
        full_name: res.full_name,
        email: res.email,
        Phone: res.phone,
        role: parseInt(res.role),
        optionsRoleValue: res.roles,
        adminRole: res.roles.some(x => x.id === 3),
        userRole: res.roles.some(x => x.id === 4),
        riskManagemntRole: res.roles.some(x => x.id === 7),
        purchaserRole: res.roles.some(x => x.id === 8),
        tecRole: res.roles.some(x => x.id === 10),
        approverRole: res.roles.some(x => x.id === 9),
        observerRole: res.roles.some(x => x.id === 11),
        emp_ref_id: res.emp_ref_id,
        isActive: res.status === 1 ? true : false,
        acountStatus: res.status,
        lockEmail: res.email === this.state.email ? false : true,
        valueCategoryCompany: mapCategoriesCompany,
      })
    }
    const waitActive = res.status === 2
    const inactive = res.status === 0
    if (inactive) {
      if (this._isMounted) {
        this.setState({
          disabledToggle: true,
        })
      }
    }
    if (waitActive) {
      if (this._isMounted) {
        this.setState({
          clickResendmail: true,
          is_active: false,
          disabledToggle: true,
        })
      }
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    if (name === 'email') {
      if (this._isMounted) {
        this.setState({ lockSave: true })
      }
    }
    if (this._isMounted) {
      this.setState({ [name]: value }, () => {
        this.validateField(name, value)
      })
    }
  }

  handleUserDropdown = optionsRole => {
    if (this._isMounted) {
      this.setState({ role: optionsRole.value }, () => {
        this.validateField(optionsRole.label, optionsRole.value)
      })
    }
  }

  togleSwitchActive = e => {
    if (this.state.clickResendmail) return
    if (this._isMounted) {
      this.setState(prevState => ({
        isActive: !prevState.isActive,
        acountStatus: !prevState.isActive ? 1 : 0,
      }))
    }
  }

  validateField = (fieldName, value) => {
    let { nameValid, emailValid, phoneValid } = this.state
    switch (fieldName) {
      case 'full_name':
        nameValid = value.length === 0
        this.setState({ nameValid })
        break
      case 'email':
        emailValid = !RegExp(EMAIL_REGEX).test(value)
        this.setState({ emailValid: emailValid })
        break
      case 'Phone':
        phoneValid = value.length === 0
        this.setState({ phoneValid })
        break
      default:
        break
    }
  }

  onChnageRole = (checked, roleID, roleName) => {
    if (checked) {
      this.state.optionsRoleValue.push({
        id: Number(roleID),
        name: roleName,
      })
      if (roleName === 'admin') {
        const optionsRoles = this.state.optionsRoleValue.filter(
          role => role.id === Number(roleID)
        )
        this.setState({ optionsRoleValue: optionsRoles })
      }
    } else {
      let index = this.state.optionsRoleValue.findIndex(
        x => x.id === Number(roleID)
      )
      this.state.optionsRoleValue.splice(index, 1)
      if (this.state.adminRole) {
        this.setState({
          userRole: false,
          riskManagemntRole: false,
          purchaserRole: false,
          tecRole: false,
          approverRole: false,
          observerRole: false,
        })
      }
    }
    this.setState({})
  }

  onFormSubmit = () => {
    this.setState({ roleValid: true })
    const { valueCategoryCompany } = this.state
    if (
      !this.state.nameValid &&
      !this.state.emailValid &&
      !this.state.phoneValid &&
      this.state.optionsRoleValue.length !== 0 &&
      valueCategoryCompany.length !== 0
    ) {
      const filterCategoriesCompany = filter(valueCategoryCompany, data => {
        const { value } = data
        if (value !== 'All') {
          return data
        }
      })
      const mapCategoriesCompany = map(filterCategoriesCompany, data => {
        const { value } = data
        return {
          id: value,
        }
      })
      const data = {
        buyer_id: parseInt(this.state.id),
        // email: trimmedString(this.state.email),
        full_name: this.state.full_name.trim(),
        Phone: this.state.Phone.trim(),
        emp_ref_id: this.state.emp_ref_id.trim(),
        // role: parseInt(this.state.role),
        status: this.state.acountStatus,
        roles: this.state.optionsRoleValue,
        categories: mapCategoriesCompany,
      }
      this.setState(
        {
          formValid: true,
        },
        () => {
          usermanageController()
            .updateBuyer(data)
            .then(async res => {
              const { user } = store.getState()
              const { id } = this.state
              const self = this
              // setTimeout(() => {
              //   toastActive(res.message)
              //   this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
              // }, 500)
              function timeOutChangeRole() {
                const promise = new Promise(function (resolve, reject) {
                  window.setTimeout(function () {
                    toastActive(res.message)
                    self.props.history.push(
                      ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK
                    )
                    resolve(true)
                  }, 500)
                })
                return promise
              }
              timeOutChangeRole().then(function (done) {
                if (done) {
                  if (user.id == id) {
                    setTimeout(() => {
                      window.location.href = '/'
                    }, 1500)
                  }
                }
              })
            })
            .catch(err => {
              this.setState({ lockSave: false, BuyerListLoading: false })
            })
            .finally(
              () => this.setState({ lockSave: true, BuyerListLoading: false })
              // this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
            )
        }
      )
    }

    // console.log('data : ', data)
    // e.preventDefault()
  }

  onFormSubmitEmail = e => {
    let data = {
      buyer_id: parseInt(this.state.id),
      email: this.state.email,
      // full_name: this.state.full_name,
      // Phone: this.state.Phone,
      // emp_ref_id: this.state.emp_ref_id,
      // role: parseInt(this.state.role),
    }

    e.preventDefault()
    if (!this.state.nameValid && !this.state.emailValid) {
      this.setState(
        {
          submitted: false,
          formValid: true,
          BuyerListLoading: true,
        },
        () =>
          usermanageController()
            .updateEmailBuyer(data)
            .then(res => {
              setTimeout(() => {
                if (res) {
                  if (res.status === 'EmailDuplicate') {
                    this.setState({
                      submitted: true,
                    })
                    toast('Email duplicate please change email', {
                      position: 'top-center',
                      autoClose: 3000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                      type: 'error',
                    })
                  } else if (res.status === 'UpdateSuccess') {
                    this.setState({
                      submitted: true,
                      clickResendmail: true,
                      isActive: false,
                      acountStatus: 2,
                    })
                    toastActive('Resend Activation Email')
                  }
                }
              }, 500)
            })
            .finally(() =>
              this.setState({ lockSave: false, BuyerListLoading: false })
            )
      )
    }
  }

  renderuserEditFormBuyer() {
    const { optionsRole, BuyerList, isActive, isEvent } = this.state
    const { role } = store.getState()
    const renderPageTitle = () => {
      const handlerOnClickBreadcrumb = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      const handlerOnClickBreadcrumb2 = e => {
        return this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_form"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_form" className="title">
                User Management
              </Section>

              <Section id="page_breadcrumb_user_form" className="breadcrumbs">
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const renderPageContent = () => {
      const errFullName = () => {
        if (this.state.nameValid) {
          return 'is-error'
        }
        return ''
      }
      const messageErrFullName = () => {
        if (this.state.nameValid) {
          return STRING.INVALID
        }
        return ''
      }
      const errEmail = () => {
        if (!this.state.emailValid) {
          return ''
        } else {
          if (!this.state.formValid) {
            return ''
          } else {
            return 'is-error'
          }
        }
      }
      const handlerClickActivationEmail = e => {
        if (e.detail === 1) {
          return this.onFormSubmitEmail(e)
        }
      }
      const submittedActivationEmail = () => {
        if (this.state.submitted) {
          return 'Resend Activation Email'
        } else {
          return <span className="loader"></span>
        }
      }
      const errPhone = () => {
        if (this.state.phoneValid) {
          return 'is-error'
        } else {
          return ''
        }
      }
      const errPhoneFormgroup = () => {
        if (!this.state.phoneValid) {
          return ''
        } else {
          if (this.state.formValid) {
            return ''
          } else {
            return 'is-error'
          }
        }
      }
      const messageErrPhone = () => {
        if (this.state.phoneValid) {
          return STRING.INVALID
        } else {
          return ''
        }
      }
      const errUserRole = () => {
        if (this.state.optionsRoleValue.length == 0 && this.state.roleValid) {
          return 'is-error'
        } else {
          return ''
        }
      }
      const onChangeOptionsRoleAdmin = e => {
        this.setState({ adminRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'admin')
      }
      const onChangeOptionsRoleUser = e => {
        this.setState({ userRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'user')
      }
      const onChangeOptionsRoleRisk = e => {
        this.setState({
          riskManagemntRole: e.target.checked,
        })
        return this.onChnageRole(
          e.target.checked,
          e.target.value,
          'risk_management'
        )
      }
      const onChangeOptionsRolePurchaser = e => {
        this.setState({ purchaserRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'purchaser')
      }
      const onChangeOptionsRoleTec = e => {
        this.setState({ tecRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'tec')
      }
      const onChangeOptionsRoleApprover = e => {
        this.setState({ approverRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'approver')
      }
      const onChangeOptionsRoleObserver = e => {
        this.setState({ observerRole: e.target.checked })
        return this.onChnageRole(e.target.checked, e.target.value, 'observer')
      }
      const errOptionsRole = () => {
        if (this.state.optionsRoleValue.length == 0) {
          return <Section className="message">{STRING.INVALID}</Section>
        } else {
          return <Section className="message"></Section>
        }
      }
      const handlerClickUserManagement = e => {
        return this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
      }
      const handlerClickResendEmail = e => {
        if (e.detail === 1) {
          if (this.state.lockSave !== true) {
            const { valueCategoryCompany } = this.state
            if (valueCategoryCompany.length === 0) {
              this.setState({ isErrorCategoryCompany: true })
            } else {
              this.setState({ isErrorCategoryCompany: false })
            }
            return this.onFormSubmit()
          } else {
            return toastFail('Please Resend Activation Email')
          }
        }
      }
      const renderRole = () => {
        return (
          <Section className="form-group-control">
            <Section className="form-group-inner-wrapper">
              <Section className="checkbox-group">
                <Checkbox
                  id="optionsRole_Admin"
                  value="3"
                  otherProps
                  checked={this.state.adminRole}
                  onChange={onChangeOptionsRoleAdmin}
                >
                  Admin
                </Checkbox>
                <Checkbox
                  id="optionsRole_Approver"
                  value="9"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={
                    this.state.adminRole ? false : this.state.approverRole
                  }
                  onChange={onChangeOptionsRoleApprover}
                >
                  Approver
                </Checkbox>
                <Checkbox
                  id="optionsRole_Observer"
                  value="11"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={
                    this.state.adminRole ? false : this.state.observerRole
                  }
                  onChange={onChangeOptionsRoleObserver}
                >
                  Observer
                </Checkbox>
                <Checkbox
                  id="optionsRole_Purchaser"
                  value="8"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={
                    this.state.adminRole ? false : this.state.purchaserRole
                  }
                  onChange={onChangeOptionsRolePurchaser}
                >
                  Purchaser
                </Checkbox>
                <Checkbox
                  id="optionsRole_Risk"
                  value="7"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={
                    this.state.adminRole ? false : this.state.riskManagemntRole
                  }
                  onChange={onChangeOptionsRoleRisk}
                >
                  Risk Management
                </Checkbox>
                <Checkbox
                  id="optionsRole_TEC"
                  value="10"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={this.state.adminRole ? false : this.state.tecRole}
                  onChange={onChangeOptionsRoleTec}
                >
                  TEC
                </Checkbox>
                <Checkbox
                  id="optionsRole_User"
                  value="4"
                  className={this.state.adminRole ? 'is-disabled' : null}
                  checked={this.state.adminRole ? false : this.state.userRole}
                  onChange={onChangeOptionsRoleUser}
                >
                  User
                </Checkbox>
              </Section>
            </Section>
            {errOptionsRole()}
          </Section>
        )
      }
      const renderOptionsCategory = () => {
        const {
          categoryCompany,
          valueCategoryCompany,
          isErrorCategoryCompany,
        } = this.state
        const handleChange = select => {
          if (this._isMounted) {
            if (select) {
              this.setState({
                valueCategoryCompany: select,
                isErrorCategoryCompany: false,
              })
            }
          }
        }
        return (
          <Section className="form-group-control">
            <Section className="form-group-inner-wrapper">
              <SelectBoxCategoryUser
                options={categoryCompany}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option,
                  MultiValue,
                  ValueContainer,
                  animatedComponents,
                }}
                allowSelectAll={true}
                onChange={handleChange}
                fieldValue={valueCategoryCompany}
                isErrCategory={isErrorCategoryCompany}
              />
            </Section>
            {isErrorCategoryCompany ? (
              <Section style={{ opacity: '1' }} className="message">
                {STRING.INVALID}
              </Section>
            ) : (
              <Section style={{ opacity: '1' }} className="message"></Section>
            )}
          </Section>
        )
      }
      const renderButtonEmail = BuyerList => {
        const {
          email,
          lockSave,
          isActive,
          emailValid,
          acountStatus,
        } = this.state
        const { email: buyerListEmail } = BuyerList
        if (acountStatus == 2) {
          return (
            <Button
              className="theme-blue resend-activation-email"
              onClick={handlerClickActivationEmail}
            >
              {submittedActivationEmail()}
            </Button>
          )
        } else {
          return null
        }
        // else if (isActive && email === buyerListEmail) {
        //   return (
        //     <Button
        //       className="theme-blue resend-activation-email"
        //       disabled={true}
        //     >
        //       {submittedActivationEmail()}
        //     </Button>
        //   )
        // } else if (email !== buyerListEmail && !emailValid) {
        //   return (
        //     <Button
        //       className="theme-blue resend-activation-email"
        //       onClick={handlerClickActivationEmail}
        //     >
        //       {submittedActivationEmail()}
        //     </Button>
        //   )
        // } else if (email !== buyerListEmail && emailValid) {
        //   return (
        //     <Button
        //       className="theme-blue resend-activation-email"
        //       disabled={true}
        //     >
        //       {submittedActivationEmail()}
        //     </Button>
        //   )
        // }
      }
      return (
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper" key={this.state.id}>
              <Section className="form-group-title">Edit User</Section>
              <Section className={`form-group ${errFullName()}`}>
                <label>Full Name</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="fullname"
                      className={`${errFullName()}`}
                      type="text"
                      name="full_name"
                      value={this.state.full_name}
                      onChange={this.handleUserInput}
                    />
                  </Section>
                  <Section className="message">{messageErrFullName()}</Section>
                </Section>
              </Section>
              <Section className={`form-group ${errEmail()}`}>
                <label>Email</label>
                <Section className="form-group-control with-button">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="email"
                      className={`${errEmail()}`}
                      type="text"
                      name="email"
                      disabled="true"
                      value={this.state.email}
                      onChange={this.handleUserInput}
                    />
                    {renderButtonEmail(BuyerList)}
                  </Section>
                  <Section className="message">{STRING.EMAIL_INVALID}</Section>
                </Section>
              </Section>
              <Section className={`form-group ${errPhone()}`}>
                <label>Phone</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="Phone"
                      className={`form-group ${errPhoneFormgroup()}`}
                      type="text"
                      name="Phone"
                      value={this.state.Phone}
                      onChange={this.handleUserInput}
                    />
                  </Section>
                  <Section className="message">{messageErrPhone()}</Section>
                </Section>
              </Section>
              <Section className="form-row">
                <Section className="form-col col-6">
                  <Section className={`form-group user-role ${errUserRole()}`}>
                    <label>Role</label>
                    {renderRole()}
                  </Section>
                </Section>
                <Section className="form-col col-6">
                  <Section
                    className={
                      'form-group user-role' +
                      (this.state.isErrorCategoryCompany && ' is-error')
                    }
                  >
                    <label>Category</label>
                    {renderOptionsCategory()}
                  </Section>
                </Section>
              </Section>
              <Section className="form-group">
                <label>
                  Employee Reference ID <br /> (Optional)
                </label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      type="text"
                      name="emp_ref_id"
                      value={this.state.emp_ref_id}
                      onChange={this.handleUserInput}
                    />
                  </Section>
                </Section>
              </Section>
              <Section className="form-group">
                <label>Active</label>
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Switcher
                      onChange={() => this.togleSwitchActive(isActive)}
                      checked={isActive}
                    />
                  </Section>
                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>
            <Section className="form-actions">
              <Button
                className="theme-border-gray"
                onClick={handlerClickUserManagement}
              >
                Cancel
              </Button>
              <Button
                className="theme-green"
                onClick={handlerClickResendEmail}
                disabled={this.state.lockSave}
              >
                Save
              </Button>
            </Section>
          </Section>
        </Section>
      )
    }
    return (
      <UserEditFormBuyerStyle>
        {renderPageTitle()}
        {renderPageContent()}
      </UserEditFormBuyerStyle>
    )
  }
  componentWillUnmount = () => {
    this._isMounted = false
  }
  render() {
    return this.renderuserEditFormBuyer()
  }
}
